export default __webpack_public_path__ + "static/media/16.1a5865aa.png";